import { OverlayService } from './../../../../services/overlay.service';
import {
    Component,
    ElementRef,
    HostListener,
    Inject,
    Input, OnChanges,
    OnDestroy,
    PLATFORM_ID,
    ViewChild
} from '@angular/core';
import KeenSlider from 'keen-slider';
import { Store } from '../../../../store';
import { iif, Observable } from "rxjs";
import { isPlatformBrowser } from "@angular/common";
import { debounce } from 'lodash';

@Component({
    selector: 'app-product-details-slider',
    templateUrl: './product-details-slider.component.html',
    styleUrls: ['./product-details-slider.component.scss']
})
export class ProductDetailsSliderComponent implements OnChanges, OnDestroy {
    @Input() images;
    @Input() discount;
    @Input() showMainImage = true;
    @Input() border = 6;
    @Input() arrowColour = '#fff';
    @Input() height = 250;
    @Input() spacing = 15;
    @Input() slidesPerView = 4;
    @Input() showDots = true;
    @Input() showNav = true;
    @Input() showExpandArrows = true;

    @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;

    initialSlides = null;
    currentSlide = 0;
    lastSlide: number;
    dotHelper: Array<number> = [];
    slider: any = null;
    innerWidth$ = this.store.select<number>('innerWidth');
    deviceType$ = this.store.select<string>('deviceType');
    settings$ = this.store.select<any>('settings');
    rewardDiscount;
    user = this.store.selectForLocal('user');
    private isBrowser: boolean;

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.removeFillerImages();
    }

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        @Inject(PLATFORM_ID) platformId: {}
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.initSlider = debounce(this.initSlider, 50);
    }
    ngOnInit(): void {
        if(this.user){
                
            this.rewardDiscount = this.user.rewardDiscount;
        }else{
            this.rewardDiscount = 0;

        }
    }
    ngOnChanges(): void {
        if (this.slider) {
            this.slider.destroy();
        }
        this.removeFillerImages();
        this.lastSlide = this.images.length - 1;
        this.initialSlides = this.images.length;
        if (this.images.length < 4) {
            let counter = this.images.length;
            while (counter < 4) {
                counter++;
                this.images.push({
                    url: null,
                });
            }
        }
        this.initSlider();
    }

    initSlider() {
        iif(
            () => this.isBrowser,
            new Observable((observer) => {
                this.slider = new KeenSlider(this.sliderRef.nativeElement, {
                    slidesPerView: this.slidesPerView,
                    spacing: this.spacing,
                    loop: false,
                    slideChanged: s => {
                        this.currentSlide = s.details().relativeSlide;
                    },
                    dragEnd: s => {
                        if (this.currentSlide - 1 === this.lastSlide) {
                            s.moveToSlideRelative(this.lastSlide);
                        }
                    }
                });

                if (this.initialSlides) {
                    const dots = (this.initialSlides - this.slidesPerView) + 1;
                    this.dotHelper = dots < 0 ? [] : [...Array(dots)];
                } else {
                    this.dotHelper = [];
                }
                observer.next();
                observer.complete();
            })
        ).subscribe();
    }

    ngOnDestroy(): void {
        if (this.slider) {
            this.slider.destroy();
        }
    }

    slidePrev() {
        if (this.currentSlide !== 0) {
            this.slider.moveToSlideRelative(--this.currentSlide);
        }
    }

    slideNext() {
        if (this.currentSlide !== this.lastSlide) {
            this.currentSlide++;
            this.slider.moveToSlideRelative(this.findNextSlide());
        }
    }

    findNextSlide() {
        let nextSlide = null;
        for (let i = this.currentSlide; i < this.images.length; i++) {
            if (this.images[i].url) {
                if (!nextSlide) {
                    nextSlide = i;
                }
            }
        }

        if (nextSlide) {
            return nextSlide;
        } else {
            return this.currentSlide;
        }

    }

    removeFillerImages() {
        let index = 0;
        while (index < this.images.length) {
            if (!this.images[index].url) {
                this.images = this.images.slice(0, index);
                if (this.slider) {
                    this.slider.resize();
                }
                break;
            }
            index++;
        }
    }

    public selectSlide(slide: any, slideIndex: any): void {
        if (slide?.url) {
            this.currentSlide = slideIndex;
        }
    }

    enterCompetition() {
        this.overlayService.toggle('enterCompetition');
    }
}
